// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';


const ConfiguredItemContributedCorrelationModalItem = ({correlation}) => {

  const classNames = classnames({
    'configured-item-contributed-correlation-modal__correlation': true,
    'configured-item-contributed-correlation-modal__correlation--required': correlation.required
  });

  return (
    <li className={classNames}>
      {correlation.title}
    </li>
  );
};

ConfiguredItemContributedCorrelationModalItem.propTypes = {
  correlation: PropTypes.object.isRequired
};

export default ConfiguredItemContributedCorrelationModalItem;



// WEBPACK FOOTER //
// ./src/components/sources/ConfiguredItemContributedCorrelationModalItem.js